module.exports = __webpack_public_path__ + "static/img/top_bg.6ebf5ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coupon/top_bg.png
// module id = UOM7
// module chunks = 1